export const aboutTextEn = `“Our team believe that people should have freedom and enjoy living their live
Be-Live aim to enable Organizations to empower employees to fulfill their lifestyle”`

export const aboutTextTh = `“Our team believe that people should have freedom and enjoy living their live
Be-Live aim to enable Organizations to empower employees to fulfill their lifestyle”`
